import React from 'react';
import {
    BranchComparison,
    CategoryAnalysis,
    HourlyActivity,
    PeriodControl,
    PopularBrands,
    RevenueDynamics,
    RevenueSummary,
    TopProducts,
    Transactions,
} from './components';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

export const SalesView: React.FC = () => {
    return (
        <div
            className="mx-auto flex w-full max-w-7xl flex-col gap-8"
            {...getNodeTestIdProp('sales-page')}
            id="sales-page"
        >
            <RevenueSummary />
            <PeriodControl />
            <RevenueDynamics />
            <Transactions />
            <TopProducts />
            <PopularBrands />
            <CategoryAnalysis />
            <BranchComparison />
            <HourlyActivity />
        </div>
    );
};
